var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"blog-toasts"},_vm._l((_vm.toasts),function(toast){return _c('li',{key:toast.id},[_vm._v(_vm._s(toast.message))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }